import * as React from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Theme, makeStyles, useTheme } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { ResetPasswordGrid } from './ResetPasswordGrid';
import { VseAlertContainer } from '../alert/VseAlertContainer';
import * as SharedData from '../../features/sharedData';
import * as PasswordReset from '../../features/password';
import * as VseAlert from '../../features/alert';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  paper: {
    margin: 'auto',
    padding: theme.spacing(2),
  },
}));

export function ResetPasswordPage() {
  const theme = useTheme();
  const classes = useStyles(theme);
  const dispatch = useDispatch();
  const sharedDataState = SharedData.useVseSharedDataState();
  const passwordResetState = PasswordReset.usePasswordResetState();
  const params = useParams<{ id: string }>();
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  const token = search.get("c");

  React.useEffect(function init() {
    dispatch(PasswordReset.verify({
      id: params.id,
      token: token ? token : ''
    }));

    return function reset() {
      dispatch(PasswordReset.reset())
      dispatch(VseAlert.dismissValidationProblem());
    }
  }, [dispatch, params.id, token]);

  React.useEffect(() => {
    if (passwordResetState.loading === 'succeeded') {
      dispatch(VseAlert.dismissValidationProblem());
    }
  }, [dispatch, passwordResetState.loading]);

  React.useEffect(function loadUniversities() {
    if (sharedDataState.universityLoading === 'idle') {
      dispatch(SharedData.loadUniversities());
    }
  }, [dispatch, sharedDataState.universityLoading]);

  return (
    <main className={classes.root}>
      <VseAlertContainer />
      {passwordResetState.loading === 'failed' ? (
        <div />
      ) : (
          <Paper className={classes.paper}>
            {passwordResetState.loading === 'pending' ? (
              <ResetPasswordGrid
                universityOptions={sharedDataState.universityOptions}
                onSubmit={
                  (homeUniversityID, password, confirmPassword) => dispatch(PasswordReset.resetPassword({
                    id: params.id,
                    token: token ? token : '',
                    homeUniversityID: homeUniversityID as number,
                    password,
                    confirmPassword
                  }))
                }
              />
            ) : (passwordResetState.loading === 'succeeded' ? (
              <div>
                <Typography variant='h6'>Reset Password</Typography>
                <Typography variant='body2'>Your APRU VSE application account password has been reset. <Link to='/login'>Login to your account</Link></Typography>
              </div>
            ) : (
                <Backdrop open={true}>
                  <CircularProgress color="inherit" />
                </Backdrop>
              ))}
          </Paper>
        )}
    </main>
  );
}
